<template>
    <div class="baseTooltip">
        <p class="Rule-Selection"><span>{{ content.name }}</span></p>
        <p class="Rule-Selection"><span>Country: </span>{{ content.country }}</p>
        <p class="Rule-Selection"><span>Destination: </span>{{ content.destination }}</p>
    </div>
</template>

<script>
export default {
    data: function () {
       return {
         content: {
            color: null,
            athlete: null,
            country: null,
            total: null
         }
    }
   },
   beforeMount() {
       this.content = this.params.data
   }
}
</script>

<style scoped>

.baseTooltip {
  width: 200px;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 2px;
  box-shadow: 0 1px 2px 1px rgba(11, 11, 11, 0.05), 0 1.5px 2px -1px rgba(0, 0, 0, 0.5);
  background-color: #334450;
}

.Rule-Selection {
  align-self: stretch;
  flex-grow: 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
}

</style>
